<template>
  <v-app>
    <!-- Drawer - Mobile -->
    <app-drawer v-if="hasMobile" />
    <!-- Header -->
    <app-header />
    <!-- Hero -->
    <app-hero v-if="!is404" />
    <!-- Hero Alt Space -->
    <div v-else>
      <v-sheet v-if="hasMobile" height="70" color="transparent" />
      <v-divider />
    </div>
    <!-- Content - Default -->
    <v-content class="content__wrap content__wrap--default">
      <!-- Inner Wrap -->
      <div class="content__wrap-inner">
        <!-- Guide -->
        <v-container v-if="!isHome && false" class="py-0">
          <app-guide />
        </v-container>
        <v-divider v-if="!isHome && false" />
        <!-- Router View -->
        <div class="content__box fill-height flex-grow-1">
          <transition-page>
            <router-view class="content__view fill-height" />
          </transition-page>
        </div>
      </div>
    </v-content>
    <!-- Divider -->
    <v-divider v-if="!isHome && !is404" />
    <!-- Showcase Partners -->
    <showcase-partners v-if="!isHome && !is404" />
    <!-- Divider -->
    <v-divider />
    <!-- Contact Card -->
    <contact-card />
    <!-- Footer -->
    <app-footer v-if="!hasMobile" />
    <!-- OffScreens -->
    <off-screens />
  </v-app>
</template>

<script>
// components
import Header from '@/components/layout/Header'
import Hero from '@/components/parts/Hero'
import ContactCard from '@/components/parts/ContactCard'
import TransitionPage from '@/components/utils/TransitionPage'
import OffScreens from '@/components/layout/OffScreens'
// lazy components
const Footer = () => import('@/components/layout/Footer')
const Drawer = () => import('@/components/layout/Drawer')
const Guide = () => import('@/components/layout/Guide')
const ShowcasePartners = () => import('@/components/parts/ShowcasePartners')
// export
export default {
  name: 'App',
  // components
  components: {
    'app-header': Header,
    'app-footer': Footer,
    'app-drawer': Drawer,
    'app-guide': Guide,
    'app-hero': Hero,
    'showcase-partners': ShowcasePartners,
    'transition-page': TransitionPage,
    'contact-card': ContactCard,
    'off-screens': OffScreens
  },
  // metaInfo
  metaInfo() {
    // init info
    const info = {}
    // title template
    info.titleTemplate = titleChunk => {
      return titleChunk ? `${titleChunk} • ${this.gVars.appName}` : this.gVars.appName
    }
    // return
    return info
  }
}
</script>

<style lang="scss">
/*
*
* Import Main Styles
*/

// overrides
@import 'assets/scss/overrides';

// global
@import 'assets/scss/global';

/* General */
.content__wrap {
  padding-top: 0 !important;
}
.content__wrap-inner {
  position: relative;
}
.content__view {
  height: 100% !important;
}
</style>
